"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPasswordRecoveryTemplate = void 0;
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const typedi_1 = require("typedi");
const control_1 = require("@common/form/control");
const auth_1 = require("@auth/services/auth");
const translation_1 = require("@translation/services/translation");
/**
 * Всплывающее окно аутентификации пользователя
 */
let PasswordRecoveryPopup = class PasswordRecoveryPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = false;
        /**
         * Успешная отправка
         */
        this.success = false;
        /**
         * Форма
         */
        this.form = new control_1.Form({
            mail: new control_1.TextControl(''),
        });
        this.authService = typedi_1.Container.get(auth_1.AuthService);
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Регистрирует пользователя
     */
    recovery() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            try {
                const { mail } = this.form.getValue();
                yield this.authService.recovery(mail);
                this.success = true;
            }
            catch (err) {
                if (err.errors) {
                    this.form.setErrors(err.errors);
                }
            }
            finally {
                this.loading = false;
            }
        });
    }
    /**
     * Генерирует представление
     */
    render() {
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="Recover" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-centered modal-fullscreen">
                    <div class="modal-content">
                         <header class="art-modal__header">
                            <button class="button-close button-close--black" type="button" data-bs-dismiss="modal" aria-label="close">
                                <span class="close__icon" aria-hidden="true"></span>
                            </button>
                        </header>
                        
                        ${this.success
            ? (0, lit_html_1.html) `
                                <h2 class="modal-title">${this.translationService.instant('success')}</h2>
                                <div class="art-modal__body">
                                    <div class="mb-5">
                                        <p class="mb-3">${this.translationService.instant('av_we_sent_you_letter_with_instructions')}</p>
                                        <button class="btn btn-secondary w-100" data-bs-dismiss="modal">${this.translationService.instant('Ok')}</button>
                                    </div>
                                </div>
                            ` : (0, lit_html_1.html) `
                                <h2 class="modal-title">${this.translationService.instant('password_recovery')}</h2>
                                <div class="art-modal__body">
                                    <div class="mb-5">
                                        <p class="text-center text-sm">${this.translationService.instant('enter_your_email_address')}</p>
                                        <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('email')}" .control="${this.form.get('mail')}" @enter="${this.recovery}"></art-text-field>

                                        <div class="btn-group d-flex flex-column gap-3">
                                            <button class="btn btn-primary w-100" ?disabled="${this.loading}" @click="${this.recovery}">${this.translationService.instant('submit_email')}</button>
                                            <button class="btn btn-secondary w-100 art-ajaxer-popup-2" ?disabled="${this.loading}" data-popup="login">${this.translationService.instant('back')}</button>
                                        </div>
                                    </div>
                                </div>
                            `}
                    </div>
                </div>
            </div>
        `;
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], PasswordRecoveryPopup.prototype, "loading", void 0);
PasswordRecoveryPopup = __decorate([
    (0, decorators_js_1.customElement)('art-password-recovery-popup'),
    __metadata("design:paramtypes", [])
], PasswordRecoveryPopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getPasswordRecoveryTemplate() {
    return (0, lit_html_1.html) `<art-password-recovery-popup></art-password-recovery-popup>`;
}
exports.getPasswordRecoveryTemplate = getPasswordRecoveryTemplate;
window.PopupController.registerTemplate('password-recovery', getPasswordRecoveryTemplate);
